import {TextField} from "@mui/material";
import {forwardRef} from "react";

export const CustomPhoneInput = forwardRef((props: any, ref) => {
  return <TextField inputRef={ref} {...props} size="small" error={props.name === "error"} />;
});
